// extracted by mini-css-extract-plugin
export var container = "_cf-0";
export var infoIcon = "_cf-2";
export var titleRowCol = "_cf-1";